<template>
  <span>
    <div class="stock-store-availability simple" v-if="isPickup">
      <div :class="{ 'availability available': isAvailable, 'availability not-available': !isAvailable, 'store-selected': selectedStore }">
        <strong v-if="isAvailable && isAvailableAtPickupLocation"><span class="hide">abholbar</span> in 3 Werktagen @ {{ selectedStore.name }}</strong>
        <strong v-else-if="isAvailable"><span class="hide">abholbar</span> in 10 Werktagen @ {{ selectedStore.name }}</strong>
        <strong v-else-if="!isAvailable">nicht verfügbar @ {{ selectedStore.name }}</strong>
      </div>
    </div>
    <div class="stock-online-availability simple" v-if="!isPickup">
      <div :class="{ 'availability available': isAvailable, 'availability not-available': !isAvailable, 'store-selected': selectedStore }">
        <strong v-if="isAvailable"><span class="hide">online</span> verfügbar</strong>
        <strong v-if="!isAvailable"><span class="hide">online</span> nicht verfügbar</strong>
      </div>
    </div>
  </span>
</template>

<script>
import { loadStock, resolveStock, attachManageStock, getOrderableQty } from 'src/modules/vsf-inventory-sources/helpers/stockResolver'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      stock: null
    }
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      selectedStore: 'inventorySources/getCurrent',
      isPickup: 'inventorySources/getIsPickup'
    }),
    isAvailableAtPickupLocation () {
      return this.stock && this.stock.qtyPickup >= this.product.qty
    },
    isAvailable () {
      if (!this.stock) return false
      const orderable = getOrderableQty(this.stock, this.isPickup)
      if (orderable.unlimited) return true
      if (this.isPickup && !orderable.assigned) return false
      return orderable.qty >= Number(this.product.qty || 0)
    }
  },
  watch: {
    isAvailable () {
      this.$emit('availability')
    },
    'product.qty' () {
      this.$emit('availability')
    },
    selectedStore: {
      handler () {
        this.refreshStock()
      },
      deep: true
    },
    isPickup () {
      this.refreshStock()
    }
  },
  async mounted () {
    await loadStock(this.product)
    await attachManageStock(this.product)
    this.refreshStock()
    this.$emit('mounted')
  },
  methods: {
    refreshStock () {
      if (!this.product) return
      this.stock = resolveStock(this.product)
    }
  }
}
</script>
